export default function mpTag(event, data){
  if (typeof window.tag !== "undefined"){
    try {
      window.tag(event, data);
    } catch (err){
      console.error(err);
    }
  }
}
